const BASE_URL = "https://x-api.alpha-x.id";

const ENDPOINT = {
  HEADER: `${BASE_URL}/v1/crappo/header`,
  HERO_BANNER: `${BASE_URL}/v1/crappo/hero-banner`,
  NUMBERS: `${BASE_URL}/v1/crappo/numbers`,
  WHY_CRAPPO: `${BASE_URL}/v1/crappo/why-crappo`,
  CALCULATE: `${BASE_URL}/v1/crappo/calculate`,
  CRYPTOCURRENCIES: `${BASE_URL}/v1/crappo/cryptocurrencies`,
  INVEST: `${BASE_URL}/v1/crappo/invest-smart`,
  STATISTICS: `${BASE_URL}/v1/crappo/statistics`,
  PROFIT: `${BASE_URL}/v1/crappo/profit-investments`,
  FOOTER: `${BASE_URL}/v1/crappo/footer`,
  SUBSCRIBE: `${BASE_URL}/v1/crappo/subscribe`,
};

export default ENDPOINT;
